module.exports = __webpack_public_path__ + "img/beem-04.e9d21a26.png";